<template>
    <div>
        <div class="container lnb header login-header">
            <div class="header h_wrap pl50">
                <div class="home_icon home-logo"></div>
                <el-menu
                        class="h_nav header-nav n_nav"
                        mode="horizontal"
                        @select="handleSelect"
                        :unique-opened=true
                        :router=true
                        active-text-color="#00a5c6"
                        :default-active="this.$route.path"
                        text-color="#303133"
                        :collapse-transition="false"
                >
                    <top-menu v-for="item in menuItem"
                              :key="item.title"
                              :item="item"
                              class="temp"
                    ></top-menu>
                </el-menu>
                <div class="h_user_info_wrap" style="vertical-align:top;">
                    <button class="h_user_log_out" @click="logout">로그아웃</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from "sweetalert2";
    import alertMixins from "@/mixins/alertMixins";
    import setMenu from "@/mixins/setMenu";
    import TopMenu from "@/components/header/TopMenu";

    export default {
        name: "PageHeader",
        mixins: [alertMixins, setMenu],
        components: {TopMenu},
        props: {
            type: {default: ''},
        },
        data() {
            return {
                menuItem: [],

            }
        },
        created() {

        },
        mounted() {

        },
        beforeDestroy() {

        },
        destroyed() {
        },
        computed: {},
        methods: {
            logout() {
                Swal.fire({
                    title: '',
                    text: '로그아웃 하시겠습니까?',
                    confirmButtonText: "확인",
                    cancelButtonText: "취소",
                    showCancelButton: true,
                    // showCloseButton: true,
                    customClass: 'koreanSSam',
                }).then((result) => {
                    if (result.value) {
                        this.$localStorage.remove('token');
                        location.href = '/auth';
                    } else {

                    }
                });
            },

            handleSelect(key, keyPath) {
                // this.$router.replace(this.$route.path);
            },
        },
        watch: {},
    }
</script>

<style lang="scss">
    .temp {
        vertical-align: middle;
    }
</style>
